import { createContext, ReactNode, useContext, useMemo, useState } from "react"

const OfferSettingsContext = createContext(null)

interface IOfferSettingsProps {
  children: ReactNode
}

export const OfferSettingsProvider: React.FC<IOfferSettingsProps> = ({
  children,
}) => {
  const [isCloseButtonVisible, setIsCloseButtonVisible] = useState(true)

  const contextValue = useMemo(
    () => ({ isCloseButtonVisible, setIsCloseButtonVisible }),
    [isCloseButtonVisible],
  )

  return (
    <OfferSettingsContext.Provider value={contextValue}>
      {children}
    </OfferSettingsContext.Provider>
  )
}

export const useOfferSettings = () => useContext(OfferSettingsContext)
